import React, { useEffect, useRef, useState } from "react";
import "./NavSidebar.scss";
import {
  Alert,
  Divider,
  Dropdown,
  Empty,
  Input,
  Menu,
  Popconfirm,
  Popover,
  Tag,
  Tooltip,
} from "antd";
import { connect } from "react-redux";
import {
  GetCurrentStoreData,
  WebsitesItem,
  WebsitesState,
} from "../../../store/websites/types";
import { getActiveDomain } from "../../../helpers/websites/getActiveDomain";
import { UserState } from "../../../store/user/types";
import _ from "lodash";
import { sortByDateFn } from "../../../helpers/sortByDateFn";
import { checkIsWebsitePublished } from "../../../helpers/checkIsWebsitePublished";
import { CmsType, LoadStatus } from "../../../enums/enums";
import {
  callPageSource,
  deletePage,
  duplicatePage,
  getPageDynamicData,
  getPageLoadStatus,
  getWebsiteInitialPagesLoadStatus,
  handleOnClickPage,
  previewPage,
} from "../../../store/websitePages/thunks";
import {
  WebsitePagesItem,
  WebsitePagesState,
} from "../../../store/websitePages/types";
import { formatImageUrl } from "../../../helpers/strings/formatImageUrl";
import {
  getAgentInstallData,
  createWebsiteFromTemplate,
  getAgents,
  getCurrentAgent,
  getCurrentStoreData,
  getSingleWebsiteLoadStatus,
} from "../../../store/websites/thunks";
import {
  File,
  ArrowLeft,
  Copy,
  CornerUpRight,
  Database,
  Ellipsis,
  Globe,
  House,
  Palette,
  Plus,
  Search,
  Settings,
  Trash2,
  ChevronRight,
  ChevronDown,
  Files,
  FileText,
  BookText,
  ChartPie,
  DollarSign,
  Rocket,
  MessageCircle,
  Mail,
  Contrast,
  Paintbrush,
  Languages,
  Shield,
  ChartBarBig,
  Blocks,
  Microscope,
  Link,
  ExternalLink,
  ChartCandlestick,
  Check,
  CircleCheck,
  Lock,
} from "lucide-react";
import classNames from "classnames";
import generateRandomSubdomain from "../../../helpers/strings/generateRandomSubdomain";
import CreateNewWebsiteModal from "../CreateNewWebsiteModal";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { cloneWebsiteAsync } from "../../../helpers/async/cloneWebsiteAsync";
import { openNotification } from "../../../helpers/openNotification";
import {
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_ERROR_TITLE,
  googleFontsAPIkey,
  googleFontsEnabledClassname,
  notificationDuration,
  PATH_HISTORY_LS_KEY,
} from "../../../data/constants";
import { deleteWebsiteAsync } from "../../../helpers/async/deleteWebsiteAsync";
import {
  changeWebsitesStateGlobalData,
  cloneWebsiteWaitingForServer,
  deleteWebsiteWaitingForServer,
  removeWebsiteFromStore,
  saveSingleWebsiteInState,
  setFullWebsiteLoadStatus,
  setSettingsModalType,
  toggleWaitingForResponseOnColorPaletteChange,
  toggleWaitingForResponseOnFontChange,
} from "../../../store/websites/actions";
import { AuthState } from "../../../store/auth/types";
import {
  changePageDynamicData,
  cloneWebsitePageWaitingForServer,
  deleteWebsitePageWaitingForServer,
  fetchSingleWebsitePages,
  incrementEditorKey,
  incrementNavSidebarKey,
  removeSingleWebsitePageFromStore,
  removeWebsitePagesFromStore,
  saveWebsitesPagesInState,
  setPageLoadStatus,
  toggleWaitingForMovePageToAnotherWebsite,
} from "../../../store/websitePages/actions";
import LoaderAnimated from "../LoaderAnimated";
import DeleteButtons from "../DeleteButtons";
import { clonePageAsync } from "../../../helpers/async/clonePageAsync";
import { deletePageAsync } from "../../../helpers/async/deletePageAsync";
import PageTemplatesModal from "../PageTemplatesModal";
import { BlogPostItem, BlogPostsState } from "../../../store/blogPosts/types";
import { BlogsState } from "../../../store/blogs/types";
import {
  createAndSavePost,
  deletePost,
  duplicatePost,
  getInitialPostsStatus,
  previewPost,
} from "../../../store/blogPosts/thunks";
import { clonePostAsync } from "../../../helpers/async/clonePostAsync";
import { deletePostAsync } from "../../../helpers/async/deletePostAsync";
import {
  cloneBlogPostWaitingForServer,
  deleteBlogPostWaitingForServer,
  removeSingleBlogPostFromStore,
  saveBlogsPostsInState,
  setSinglePostStatus,
} from "../../../store/blogPosts/actions";
import SettingsModal from "../SettingsModal";
import { websiteColors } from "../../../data/websiteColors";
import ColorPaletteItem from "../ColorPaletteItem";
import { websiteFontOptions } from "../../../data/websiteFontOptions";
import FontOptionItem from "../FontOptionItem";
import SearchModal from "../SearchModal";
import ButtonStyleMenu from "../style_menu/ButtonStyleMenu";
import FontSizeMenu from "../style_menu/FontSizeMenu";
import InputStyleMenu from "../style_menu/InputStyleMenu";
import CardStyleMenu from "../style_menu/CardStyleMenu";
import ContainerStyleMenu from "../style_menu/ContainerStyleMenu";
import PageTemplatesList from "../PageTemplatesList";
import TextArea from "antd/lib/input/TextArea";
import { checkIfPageIsDynamic } from "../../../helpers/checkIfPageIsDynamic";
import getUrlParameter from "../../../helpers/getUrlParameter";
import { sheetsApi } from "../../../data/urls";
import { formatGoogleSheetUrl } from "../../../helpers/formatGoogleSheetUrl";
import axios from "axios";
import SkeletonLoader from "../SkeletonLoader";
import { getPathArray } from "../../../helpers/getPathArray";
import ChatAgent from "./ChatAgent";
import { formatHex } from "../../../helpers/editor/formatHex";
import { validateHex } from "../../../helpers/editor/validateHex";
import getContrast from "../../../helpers/editor/getContrast";
import { updateWebsiteAsync } from "../../../helpers/async/updateWebsiteAsync";
import FontPicker from "font-picker-react";
import SaveChangesButtons from "../SaveChangesButtons";
import UnsavedChangesPopconfirm from "../UnsavedChangesPopconfirm";
import CustomCssStyleMenu from "../style_menu/CustomCssStyleMenu";
import { movePageAsync } from "../../../helpers/async/movePageAsync";
import {
  setIsSearchModalVisible,
  setIsSettingsModalVisible,
  setUserStateData,
} from "../../../store/user/actions";
import { getUniqueKeys } from "../../../helpers/getUniqueKeys";
import {
  getSingleBlogLoadStatus,
  previewBlogHomePage,
} from "../../../store/blogs/thunks";
import { PlansState } from "../../../store/plans/types";
import DebouncedInput from "../../DebouncedInput";
import fuzzysort from "fuzzysort";
import { validatePath } from "../../../helpers/validatePath";
import DuePaymentAlert from "../DuePaymentAlert";
import {
  checkIfAgentsAvailable,
  isUserFreeNew,
} from "../../../store/user/thunks";
import { MetaState } from "../../../store/meta/types";
import { checkIsProPlan } from "../../../helpers/user/checkIsProPlan";
import MovePagePopover from "../../layout/MovePagePopover";
import SidebarButton from "../../layout/SidebarButton";
import SidebarSkeletonLoader from "../../layout/SidebarSkeletonLoader";

// Molecules
interface SidebarCardProps {
  isSelected?: boolean;
  isActive?: boolean;
  subtitle?: string;
  iconSrc?: string;
  title?: string;
  onClick?: () => void;
  logoColor?: string;
  isLocked?: boolean;
}
const SidebarCard = (props: SidebarCardProps) => {
  const { title, isSelected, isActive, subtitle, iconSrc, onClick, isLocked } =
    props;
  return (
    <div
      className={classNames("nav-sidebar__card", {
        "is-selected": isSelected,
        "is-active": isActive,
      })}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <div className="nav-sidebar__card-content">
        <div className="nav-sidebar__card-title-box">
          {!!iconSrc && !isLocked && (
            <div
              className="nav-sidebar__card-icon-container"
              style={{
                background: props.logoColor,
              }}
            >
              <img
                src={iconSrc}
                alt="icon"
                className="nav-sidebar__card-icon"
              />
            </div>
          )}
          {isLocked && <Lock size={16} />}
          <div className="nav-sidebar__card-title">{title}</div>
        </div>
        <div className="nav-sidebar__card-subtitle">{subtitle}</div>
      </div>
    </div>
  );
};

interface CtaButtonProps {
  icon?: React.ReactNode;
  children?: React.ReactNode | React.ReactNode[];
  onClick?: () => void;
}
const CtaButton = (props: CtaButtonProps) => {
  const { icon, children, onClick } = props;
  return (
    <button className="nav-sidebar__cta-button" onClick={onClick}>
      {icon}
      <span className="nav-sidebar__cta-button-text">{children}</span>
    </button>
  );
};

interface SidebarMenuWrapperProps {
  children?: React.ReactNode | React.ReactNode[];
  onClick?: () => void;
  title?: string;
  loading?: boolean;
  gap?: number;
}
const SidebarMenuWrapper = (props: SidebarMenuWrapperProps) => {
  const { children, onClick, title, loading, gap } = props;
  const [isOpen, setIsOpen] = useState(true);
  const contentStylePbject = {};
  if (gap) {
    contentStylePbject["gap"] = gap;
  }
  return (
    <div
      className={classNames("nav-sidebar__menu-wrapper", {
        "is-loading": loading,
      })}
    >
      {!!title && (
        <h3
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          className="nav-sidebar__menu-wrapper-title"
        >
          <span className="nav-sidebar__menu-wrapper-title-text">{title}</span>
          {!!onClick && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
              disabled={loading}
              className={classNames("nav-sidebar__menu-wrapper-title-button", {
                "is-loading": loading,
              })}
            >
              {loading && <LoaderAnimated />}
              {!loading && <Plus size={16} />}
            </button>
          )}
        </h3>
      )}
      {!!isOpen && (
        <div
          className="nav-sidebar__menu-wrapper-content"
          style={contentStylePbject}
        >
          {isOpen && children}
        </div>
      )}
    </div>
  );
};

// Main
interface Props extends RouteComponentProps {
  websites: WebsitesState;
  user: UserState;
  auth: AuthState;
  blogPosts: BlogPostsState;
  blogs: BlogsState;
  plans: PlansState;
  meta: MetaState;
  getWebsiteInitialPagesLoadStatus: any;
  websitesPages: WebsitePagesState;
  getCurrentStoreData: GetCurrentStoreData;
  createWebsiteFromTemplate: any;
  cloneWebsiteWaitingForServer: any;
  setFullWebsiteLoadStatus: any;
  fetchSingleWebsitePages: any;
  saveSingleWebsiteInState: any;
  deleteWebsiteWaitingForServer: any;
  removeWebsiteFromStore: any;
  removeWebsitePagesFromStore: any;
  cloneWebsitePageWaitingForServer: any;
  setPageLoadStatus: any;
  saveWebsitesPagesInState: any;
  deleteWebsitePageWaitingForServer: any;
  removeSingleWebsitePageFromStore: any;
  createAndSavePost: any;
  cloneBlogPostWaitingForServer: any;
  setSinglePostStatus: any;
  saveBlogsPostsInState: any;
  deleteBlogPostWaitingForServer: any;
  removeSingleBlogPostFromStore: any;
  changePageDynamicData: any;
  getPageDynamicData: any;
  saveWebsiteDataInStore: any;
  saveWebsitePageDataInStore: any;
  publishPage: any;
  saveImageInfoInDB: any;
  removeImageFromDB: any;
  saveBlogDataInStore: any;
  saveBlogPostDataInStore: any;
  publishPost: any;
  changeWebsitesStateGlobalData: any;
  getSingleWebsiteLoadStatus: any;
  toggleWaitingForMovePageToAnotherWebsite: any;
  setUserStateData: any;
  getSingleBlogLoadStatus: any;
  getPageLoadStatus: any;
  getInitialPostsStatus: any;
  toggleWaitingForResponseOnColorPaletteChange: any;
  toggleWaitingForResponseOnFontChange: any;
  callPageSource: any;
  handleOnClickPage: any;
  setIsSettingsModalVisible: (visible: boolean) => void;
  setIsSearchModalVisible: (visible: boolean) => void;
  previewPage: any;
  previewPost: any;
  previewBlogHomePage: any;
  incrementEditorKey: any;
  incrementNavSidebarKey: any;
  isUserFreeNew: any;
  getCurrentAgent: any;
  getAgents: any;
  getAgentInstallData: any;
  checkIfAgentsAvailable: any;
  setSettingsModalType: any;
  duplicatePage: any;
  deletePage: any;
  duplicatePost: any;
  deletePost: any;
}

interface WebsiteContextDropdownProps extends Props {
  children: React.ReactNode;
  website: WebsitesItem;
}
const WebsiteContextDropdown = (props: WebsiteContextDropdownProps) => {
  const { children, websites, website, getCurrentStoreData, websitesPages } =
    props;
  const {
    isWaitingForCloneWebsiteResponse,
    isWaitingForDeleteWebsiteResponse,
  } = websites;

  const { currentWebsite } = getCurrentStoreData();

  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag);
    if (!flag) {
      setIsDeleteConfirmVisible(false);
    }
  };
  const handleOnMenuClick = (e) => {
    e.domEvent.stopPropagation();
    e.domEvent.preventDefault();
  };
  const handleOnDeleteClick = (e) => {
    if (!isDeleteConfirmVisible) {
      setIsDeleteConfirmVisible(true);
    }
  };

  const duplicateWebsite = () => {
    props.cloneWebsiteWaitingForServer(true);
    cloneWebsiteAsync({
      subdomain: website.subdomain,
      accessToken: props.auth.accessToken,
    })
      .then(async (response) => {
        const { subdomain, id } = response.data;
        props.setFullWebsiteLoadStatus({
          websiteId: id,
          status: LoadStatus.LOADED,
        });
        await props.fetchSingleWebsitePages(subdomain, id);
        props.saveSingleWebsiteInState([response.data]);
        props.history.push(`/${subdomain}`);
        window.scrollTo(0, 0);
        setVisible(false);
      })
      .catch((error) => {
        console.error(error.response);
        openNotification(
          DEFAULT_ERROR_TITLE,
          DEFAULT_ERROR_MESSAGE,
          "OK",
          "error",
          notificationDuration.medium
        );
      })
      .finally(() => {
        props.cloneWebsiteWaitingForServer(false);
      });
  };

  const deleteWebsite = () => {
    props.deleteWebsiteWaitingForServer(true);
    deleteWebsiteAsync({
      accessToken: props.auth.accessToken,
      subdomain: props.website.subdomain,
    })
      .then((response) => {
        props.setFullWebsiteLoadStatus({
          websiteId: response.data.id,
          status: LoadStatus.DELETED,
        });
        props.removeWebsiteFromStore(website.subdomain);
        props.removeWebsitePagesFromStore(response.data.id);
        if (website === currentWebsite) {
          localStorage.removeItem(PATH_HISTORY_LS_KEY);
          props.history.push("/");
          window.scrollTo(0, 0);
        }
      })
      .catch((error) => {
        console.error(error.response);
        const sharedWarningMessage = _.get(error, "response.data.not_owned");
        if (sharedWarningMessage) {
          openNotification(
            "Error",
            sharedWarningMessage,
            "OK",
            "warning",
            notificationDuration.medium
          );
          return;
        }
        openNotification(
          DEFAULT_ERROR_TITLE,
          DEFAULT_ERROR_MESSAGE,
          "OK",
          "error",
          notificationDuration.medium
        );
      })
      .finally(() => {
        props.deleteWebsiteWaitingForServer(false);
      });
  };

  const menu = (
    <Menu className="nav-sidebar__dropdown-menu" onClick={handleOnMenuClick}>
      <Menu.Item
        key="duplicate"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForCloneWebsiteResponse}
        onClick={duplicateWebsite}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            {!isWaitingForCloneWebsiteResponse && <Copy size={16} />}
            {isWaitingForCloneWebsiteResponse && <LoaderAnimated />}
          </div>
          <span className="nav-sidebar__dropdown-item-name">Duplicate</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="delete"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForDeleteWebsiteResponse}
        onClick={handleOnDeleteClick}
      >
        {!isDeleteConfirmVisible && (
          <div className="nav-sidebar__dropdown-item-inner">
            <div className="nav-sidebar__dropdown-item-icon">
              <Trash2 size={16} />
            </div>
            <span className="nav-sidebar__dropdown-item-name">Delete</span>
          </div>
        )}
        {isDeleteConfirmVisible && (
          <DeleteButtons
            loading={isWaitingForDeleteWebsiteResponse}
            deleteAction={deleteWebsite}
            deleteItemTitle={"website"}
            cancelAction={() => {
              setIsDeleteConfirmVisible(false);
            }}
          />
        )}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="nav-sidebar__dropdown-overlay is-context"
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      {children}
    </Dropdown>
  );
};

interface PageContextDropdownProps extends Props {
  children: React.ReactNode;
  page: WebsitePagesItem;
  setSettingsModalType: (type: string) => void;
}
const PageContextDropdown = (props: PageContextDropdownProps) => {
  const {
    children,
    page,
    websitesPages,
    getCurrentStoreData,
    websites,
    setSettingsModalType,
    setIsSettingsModalVisible,
  } = props;
  const { currentWebsitePage, currentWebsite } = getCurrentStoreData();
  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const {
    isWaitingForCloneWebsitePageResponse,
    isWaitingForMoveWebsitePageResponse,
    isWaitingForDeleteWebsitePageResponse,
  } = websitesPages;
  const currentPageWebsite = websites.items.find(
    (website) => website.id === page.website
  );
  const [isMovePopoverVisible, setIsMovePopoverVisible] = useState(false);

  const handleVisibleChange = (flag: boolean) => {
    if (!flag && isMovePopoverVisible) {
      setTimeout(() => {
        setVisible(flag);
        if (!flag) {
          setIsDeleteConfirmVisible(false);
        }
      }, 0);
      return;
    }
    setVisible(flag);
    if (!flag) {
      setIsDeleteConfirmVisible(false);
    }
  };
  const handleOnDeleteClick = (e) => {
    if (!isDeleteConfirmVisible) {
      setIsDeleteConfirmVisible(true);
    }
  };
  const handleOnMenuClick = (e) => {
    e.domEvent.stopPropagation();
  };
  const handleOnDuplicatePage = () => {
    props.duplicatePage(page).then((response) => {
      props.history.push(
        `/${_.get(currentWebsite, "subdomain")}/pages/${response.data.id}`
      );
      window.scrollTo(0, 0);
      setVisible(false);
    });
  };

  const handleOnDeletePage = () => {
    props.deletePage(page).then(() => {
      if (currentWebsitePage === page) {
        props.history.push(`/${_.get(currentWebsite, "subdomain")}/pages`);
        window.scrollTo(0, 0);
      }
    });
  };

  const openPageSettings = () => {
    if (
      _.get(currentWebsitePage, "id") !== page.id ||
      getUrlParameter("slug")
    ) {
      props.history.push(
        `/${_.get(currentWebsite, "subdomain")}/pages/${page.id}`
      );
    }
    if (_.get(currentWebsitePage, "id") !== page.id) {
      window.scrollTo(0, 0);
    }
    setTimeout(() => {
      setSettingsModalType("page");
      setIsSettingsModalVisible(true);
      setVisible(false);
    }, 0);
  };

  const myOtherWebsites = websites.items.filter((website) => {
    return website.id !== _.get(currentWebsite, "id");
  });

  const menu = (
    <Menu className="nav-sidebar__dropdown-menu" onClick={handleOnMenuClick}>
      <Menu.Item
        key="preview"
        className="nav-sidebar__dropdown-item"
        onClick={(e) => {
          if (page.is_published) {
            props.previewPage(page.id);
            setVisible(false);
            return;
          }
          props.publishPage(
            true,
            page.url,
            currentWebsite,
            null,
            () => {
              props.previewPage(page.id);
              setVisible(false);
            },
            page.id
          );
        }}
        disabled={websitesPages.isWaitingForPublishPageResponse}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            {!websitesPages.isWaitingForPublishPageResponse && (
              <ExternalLink size={16} />
            )}
            {websitesPages.isWaitingForPublishPageResponse && (
              <LoaderAnimated />
            )}
          </div>
          <span className="nav-sidebar__dropdown-item-name">
            {page.is_published || props.isUserFreeNew()
              ? "Preview"
              : "Publish & Preview"}
          </span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="settings"
        className="nav-sidebar__dropdown-item"
        onClick={openPageSettings}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            <Settings size={16} />
          </div>
          <span className="nav-sidebar__dropdown-item-name">Settings</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="duplicate"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForCloneWebsitePageResponse}
        onClick={handleOnDuplicatePage}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            {!isWaitingForCloneWebsitePageResponse && <Copy size={16} />}
            {isWaitingForCloneWebsitePageResponse && <LoaderAnimated />}
          </div>
          <span className="nav-sidebar__dropdown-item-name">Duplicate</span>
        </div>
      </Menu.Item>
      {myOtherWebsites.length > 0 && (
        <Menu.Item
          key="move"
          className="nav-sidebar__dropdown-item"
          disabled={isWaitingForMoveWebsitePageResponse}
        >
          <MovePagePopover
            isMovePopoverVisible={isMovePopoverVisible}
            onVisibleChange={(visible) => {
              if (isWaitingForMoveWebsitePageResponse) return;
              setIsMovePopoverVisible(visible);
            }}
            page={page}
            setIsMovePopoverVisible={setIsMovePopoverVisible}
            placement="right"
          >
            <div className="nav-sidebar__dropdown-item-inner">
              <div className="nav-sidebar__dropdown-item-icon">
                {!isWaitingForMoveWebsitePageResponse && (
                  <CornerUpRight size={16} />
                )}
                {isWaitingForMoveWebsitePageResponse && <LoaderAnimated />}
              </div>
              <span className="nav-sidebar__dropdown-item-name">Move to</span>
            </div>
          </MovePagePopover>
        </Menu.Item>
      )}
      <Menu.Item
        key="delete"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForDeleteWebsitePageResponse}
        onClick={handleOnDeleteClick}
      >
        {!isDeleteConfirmVisible && (
          <div className="nav-sidebar__dropdown-item-inner">
            <div className="nav-sidebar__dropdown-item-icon">
              <Trash2 size={16} />
            </div>
            <span className="nav-sidebar__dropdown-item-name">Delete</span>
          </div>
        )}
        {isDeleteConfirmVisible && (
          <DeleteButtons
            loading={isWaitingForDeleteWebsitePageResponse}
            deleteAction={handleOnDeletePage}
            deleteItemTitle={"page"}
            cancelAction={() => {
              setIsDeleteConfirmVisible(false);
            }}
          />
        )}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="nav-sidebar__dropdown-overlay is-context"
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      {children}
    </Dropdown>
  );
};

interface BlogContextDropdownProps extends Props {
  children: React.ReactNode;
  setSettingsModalType: (type: string) => void;
}
const BlogContextDropdown = (props: BlogContextDropdownProps) => {
  const {
    children,
    websitesPages,
    getCurrentStoreData,
    websites,
    setIsSettingsModalVisible,
    setSettingsModalType,
  } = props;
  const { currentWebsitePage, currentWebsite, currentBlog } =
    getCurrentStoreData();
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag);
  };
  const handleOnMenuClick = (e) => {
    e.domEvent.stopPropagation();
  };

  const openBlogSettings = () => {
    setTimeout(() => {
      props.setUserStateData({
        settings: "blogSettings",
      });
      setSettingsModalType("website");
      setIsSettingsModalVisible(true);
      setVisible(false);
    }, 0);
  };

  const menu = (
    <Menu className="nav-sidebar__dropdown-menu" onClick={handleOnMenuClick}>
      <Menu.Item
        key="preview"
        className="nav-sidebar__dropdown-item"
        onClick={() => {
          setVisible(false);
          props.previewBlogHomePage(currentBlog.id);
        }}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            <ExternalLink size={16} />
          </div>
          <span className="nav-sidebar__dropdown-item-name">Preview</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="settings"
        className="nav-sidebar__dropdown-item"
        onClick={openBlogSettings}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            <Settings size={16} />
          </div>
          <span className="nav-sidebar__dropdown-item-name">Settings</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="nav-sidebar__dropdown-overlay is-context"
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      {children}
    </Dropdown>
  );
};

interface PageItemProps extends Props {
  page: WebsitePagesItem;
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  setIsSearchModalVisible: (visible: boolean) => void;
  setSettingsModalType: (type: string) => void;
  setDynamicPageMenuId: any;
  dynamicPageMenuId: any;
  expandedItems: any;
  setExpandedItems: any;
  scrollToTop: () => void;
}
const PageItem = (props: PageItemProps) => {
  const {
    page,
    websitesPages,
    setSidebarMenu,
    sidebarMenu,
    setIsSearchModalVisible,
    setIsSettingsModalVisible,
    setSettingsModalType,
    setDynamicPageMenuId,
    dynamicPageMenuId,
    expandedItems,
    setExpandedItems,
    scrollToTop,
  } = props;
  const { currentWebsite, currentWebsitePage } = props.getCurrentStoreData();
  if (!currentWebsite) return null;

  const pageUrl = page.url || "home";
  const isPageDynamic = checkIfPageIsDynamic(page);
  const slugParam = getUrlParameter("slug");
  const isCurrentPageSelected = _.get(currentWebsitePage, "id") === page.id;
  const isItemSelected = isCurrentPageSelected && !slugParam;

  useEffect(() => {
    props.callPageSource({ page });
  }, [
    _.get(page, "cms.cmsType"),
    _.get(page, "cms.unicorn.collectionId"),
    _.get(page, "cms.googleSheets.url"),
    page.api_source_url,
  ]);

  let expandItems = [];

  const pageDynamicData = props.getPageDynamicData({
    page,
  });

  const isSlugsLoading = pageDynamicData.isLoading;

  if (isPageDynamic) {
    expandItems = pageDynamicData.slugs.map((slug) => {
      return {
        title: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {!!page.url && (
              <span
                style={{ color: "#8c8c8c" }}
                className="nav-sidebar__button-expand-item-prefix"
              >
                /{page.url}
              </span>
            )}
            <span className="nav-sidebar__button-expand-item-name">
              /{slug}
            </span>
          </span>
        ),
        onClick: () => {
          props.handleOnClickPage({
            pageId: page.id,
            slug,
            history: props.history,
          });
        },
        isSelected: slugParam === slug && isCurrentPageSelected,
        tooltip: page.url ? `/${page.url}/${slug}` : `/${slug}`,
      };
    });
  }

  const iconStyle = {
    opacity: page.is_published ? 1 : 0.5,
  };

  return (
    <SidebarButton
      tooltip={
        <div className="nav-sidebar__button-tooltip-content">
          <div className="nav-sidebar__button-tooltip-title">
            {page.url ? `/${page.url}` : "Home page"}
          </div>
          <div className="nav-sidebar__button-tooltip-subtitle">
            {page.is_published ? "Published" : "Not published"}
          </div>
        </div>
      }
      isDefaultExpanded={expandedItems.includes(page.id)}
      afterOpenExpandCallback={() => {
        setExpandedItems([...expandedItems, page.id]);
      }}
      afterCloseExpandCallback={() => {
        setExpandedItems(expandedItems.filter((item) => item !== page.id));
      }}
      key={pageUrl}
      icon={
        isPageDynamic ? (
          <Files size={16} style={iconStyle} />
        ) : pageUrl === "home" ? (
          <House size={16} style={iconStyle} />
        ) : (
          <File size={16} style={iconStyle} />
        )
      }
      contextButton={
        <PageContextDropdown
          {...props}
          page={page}
          setSettingsModalType={setSettingsModalType}
        >
          <span
            className="nav-sidebar__button-context-button"
            onClick={(e) => e.stopPropagation()}
          >
            <Ellipsis size={16} />
          </span>
        </PageContextDropdown>
      }
      isSelected={isItemSelected}
      onClick={() => {
        props.handleOnClickPage({ pageId: page.id, history: props.history });
      }}
      expand={
        !isPageDynamic || _.get(page, "cms.cmsType") === "custom"
          ? null
          : expandItems
      }
      isExpandLoading={isSlugsLoading}
      expandLimit={3}
      expandShowAllOnClick={() => {
        scrollToTop();
        setDynamicPageMenuId(page.id);
        setSidebarMenu("dynamicPage");
      }}
    >
      <span>
        {pageUrl !== "home" && "/"}
        {pageUrl === "home" ? "Home" : pageUrl}
      </span>
    </SidebarButton>
  );
};

interface WebsiteMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  setSettingsModalType: (type: string) => void;
  setDynamicPageMenuId: any;
  dynamicPageMenuId: any;
  expandedItems: any;
  setExpandedItems: any;
  scrollToTop: () => void;
}
const WebsiteMenu = (props: WebsiteMenuProps) => {
  const {
    websitesPages,
    setSidebarMenu,
    sidebarMenu,
    setIsSearchModalVisible,
    setIsSettingsModalVisible,
    setSettingsModalType,
    setDynamicPageMenuId,
    dynamicPageMenuId,
    expandedItems,
    setExpandedItems,
    scrollToTop,
  } = props;
  const { currentWebsite, currentBlog } = props.getCurrentStoreData();

  const [isPageModalVisible, setIsPageModalVisible] = useState(false);

  const mapPagesFn = (page) => {
    return <PageItem key={page.id} {...props} page={page} />;
  };

  const pages = websitesPages.items
    .filter((page) => page.website === _.get(currentWebsite, "id"))
    .filter((page) => page.url !== "")
    .sort(sortByDateFn)
    .sort((a, b) => {
      const isADynamic = checkIfPageIsDynamic(a);
      const isBDynamic = checkIfPageIsDynamic(b);
      if (isADynamic && !isBDynamic) return -1;
      if (!isADynamic && isBDynamic) return 1;
    })
    .sort((a, b) => {
      if (a.url === "") return -1;
      if (b.url === "") return 1;
      return 0;
    })
    .map(mapPagesFn);

  const currentWebsitePages = websitesPages.items.filter((page) => {
    return page.website === _.get(currentWebsite, "id");
  });

  const homePage = currentWebsitePages.find((page) => page.url === "");
  const siteHasNoPages = !currentBlog && !homePage && pages.length === 0;
  const initialPagesStatus =
    props.getWebsiteInitialPagesLoadStatus(currentWebsite);

  const isPagesLoaded =
    props.blogs.dataFetched && initialPagesStatus === LoadStatus.LOADED;

  const publishedBlogPostsCount = props.blogPosts.items.filter((post) => {
    return post.blog === _.get(currentBlog, "id") && post.status === "public";
  }).length;

  return (
    <>
      <div className="nav-sidebar__fixed-navigation">
        <WebsiteSelector {...props} setSidebarMenu={setSidebarMenu} />
        <TopButtons
          {...props}
          setSidebarMenu={setSidebarMenu}
          sidebarMenu={sidebarMenu}
          setSettingsModalType={setSettingsModalType}
        />
      </div>
      <div className="nav-sidebar__menu-container">
        {!!currentWebsite && (
          <>
            {!isPagesLoaded && (
              <SidebarMenuWrapper title="Pages">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                    padding: "0 8px",
                  }}
                >
                  <SidebarSkeletonLoader hasIcon width="120px" />
                  <SidebarSkeletonLoader hasIcon width="85px" />
                  <SidebarSkeletonLoader hasIcon width="140px" />
                  <SidebarSkeletonLoader hasIcon width="110px" />
                  <SidebarSkeletonLoader hasIcon width="95px" />
                  <SidebarSkeletonLoader hasIcon width="130px" />
                  <SidebarSkeletonLoader hasIcon width="100px" />
                  <SidebarSkeletonLoader hasIcon width="115px" />
                  <SidebarSkeletonLoader hasIcon width="90px" />
                  <SidebarSkeletonLoader hasIcon width="125px" />
                </div>
              </SidebarMenuWrapper>
            )}
            {isPagesLoaded && (
              <SidebarMenuWrapper
                title="Pages"
                onClick={() => {
                  setSidebarMenu("pageTemplates");
                }}
              >
                {!!homePage && (
                  <PageItem key={homePage.id} {...props} page={homePage} />
                )}
                {!!currentBlog && (
                  <SidebarButton
                    tooltip={
                      <div className="nav-sidebar__button-tooltip-content">
                        <div className="nav-sidebar__button-tooltip-title">
                          Blog
                        </div>
                        <div className="nav-sidebar__button-tooltip-subtitle">
                          {publishedBlogPostsCount} published post
                          {publishedBlogPostsCount !== 1 ? "s" : ""}
                        </div>
                      </div>
                    }
                    onClick={() => {
                      props.history.push(
                        `/${_.get(currentWebsite, "subdomain")}/blog`
                      );
                      window.scrollTo(0, 0);
                      scrollToTop();
                      setSidebarMenu("blog");
                    }}
                    icon={<BookText size={16} />}
                    contextButton={
                      <BlogContextDropdown
                        {...props}
                        setSettingsModalType={setSettingsModalType}
                      >
                        <span
                          className="nav-sidebar__button-context-button"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Ellipsis size={16} />
                        </span>
                      </BlogContextDropdown>
                    }
                  >
                    Blog
                  </SidebarButton>
                )}
                {pages}
                {siteHasNoPages && (
                  <Empty
                    description="No pages yet"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ margin: 0, marginTop: 16 }}
                  />
                )}
              </SidebarMenuWrapper>
            )}
          </>
        )}
        {/* <ChatAgent /> */}
        <PageTemplatesModal
          currentWebsitePages={currentWebsitePages}
          isPageModalVisible={isPageModalVisible}
          handlePagesModalCancel={() => {
            setIsPageModalVisible(false);
          }}
        />
      </div>
    </>
  );
};

interface ColorsSelectorProps extends Props {}
const ColorsSelector = (props: ColorsSelectorProps) => {
  const { currentWebsite } = props.getCurrentStoreData();
  const [isLoading, setIsLoading] = useState(false);
  const customPalette: any = _.get(currentWebsite, "custom_color_palette", {});

  const [primaryColor, setPrimaryColor] = useState(
    customPalette.primaryButton || ""
  );
  const [secondaryColor, setSecondaryColor] = useState(
    customPalette.secondaryButton || ""
  );
  const [accentColor, setAccentColor] = useState(customPalette.accent || "");

  const [displayedPrimaryColor, setDisplayedPrimaryColor] = useState(
    customPalette.primaryButton || ""
  );
  const [displayedSecondaryColor, setDisplayedSecondaryColor] = useState(
    customPalette.secondaryButton || ""
  );
  const [displayedAccentColor, setDisplayedAccentColor] = useState(
    customPalette.accent || ""
  );

  const handleOnConfirm = () => {
    props.toggleWaitingForResponseOnColorPaletteChange(true);
    setIsLoading(true);
    const updatedCustomColorPaletteObject = {
      ...customPalette,

      primaryButton: displayedPrimaryColor,
      secondaryButton: displayedSecondaryColor,
      accent: displayedAccentColor,

      primaryButtonHover: (window as any)["changeBrightness"](
        -0.2,
        displayedPrimaryColor
      ),
      secondaryButtonHover: (window as any)["changeBrightness"](
        -0.2,
        displayedSecondaryColor
      ),
      isPrimaryButtonColorBright: getContrast(displayedPrimaryColor),
      isSecondaryButtonColorBright: getContrast(displayedSecondaryColor),
      isAccentColorBright: getContrast(displayedAccentColor),
      isCustomPaletteActivated: true,
    };
    updateWebsiteAsync({
      accessToken: props.auth.accessToken,
      subdomain: _.get(currentWebsite, "subdomain"),
      data: {
        custom_color_palette: updatedCustomColorPaletteObject,
      },
    })
      .then((response) => {
        const dataToStore = {
          data: {
            ...currentWebsite,
            custom_color_palette: updatedCustomColorPaletteObject,
          },
        };
        props.saveWebsiteDataInStore(
          dataToStore,
          _.get(currentWebsite, "subdomain")
        );
      })
      .catch((error) => {
        console.error(error);
        console.error(error.response);
        openNotification(
          DEFAULT_ERROR_TITLE,
          DEFAULT_ERROR_MESSAGE,
          "OK",
          "error",
          notificationDuration.medium
        );
      })
      .finally(() => {
        props.toggleWaitingForResponseOnColorPaletteChange(false);
        setIsLoading(false);
      });
  };

  return (
    <div className="comps nav-sidebar__theme">
      {websiteColors.map((item: any, key: number) => {
        return (
          <ColorPaletteItem
            key={key}
            styleClassname={item.styleClassname}
            styleTitle={item.styleTitle}
            saveWebsiteDataInStore={props.saveWebsiteDataInStore}
            colorItem={item}
          />
        );
      })}
      <Popconfirm
        overlayStyle={{
          position: "fixed",
        }}
        placement="rightBottom"
        overlayClassName="nav-sidebar__custom-color"
        align={{ offset: [-32, -16] }}
        icon={null}
        disabled={props.websites.isWaitingForChangeColorPaletteServerResponse}
        title={
          <div className="nav-sidebar__custom-color-wrapper custom-colors-enabled">
            <div className="nav-sidebar__custom-color-inputs">
              <div className="nav-sidebar__custom-color-input-row">
                <span className="nav-sidebar__custom-color-input-row-label">
                  Primary
                </span>
                <div className="nav-sidebar__custom-color-input-item">
                  <span
                    className="nav-sidebar__custom-color-preview"
                    style={{
                      backgroundColor: displayedPrimaryColor,
                    }}
                  />
                  <Input
                    value={primaryColor}
                    onChange={(e) => {
                      setPrimaryColor(e.target.value);
                    }}
                    size="small"
                    placeholder="#fff"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.currentTarget.blur();
                      }
                    }}
                    onBlur={() => {
                      const formattedHex = formatHex(primaryColor, true);
                      if (!validateHex(formattedHex)) {
                        setPrimaryColor(customPalette.primaryButton);
                        setDisplayedPrimaryColor(customPalette.primaryButton);
                        return;
                      }
                      setPrimaryColor(formattedHex);
                      setDisplayedPrimaryColor(formattedHex);
                    }}
                  />
                </div>
              </div>
              <div className="nav-sidebar__custom-color-input-row">
                <span className="nav-sidebar__custom-color-input-row-label">
                  Secondary
                </span>
                <div className="nav-sidebar__custom-color-input-item">
                  <span
                    className="nav-sidebar__custom-color-preview"
                    style={{
                      backgroundColor: displayedSecondaryColor,
                    }}
                  />
                  <Input
                    value={secondaryColor}
                    onChange={(e) => setSecondaryColor(e.target.value)}
                    size="small"
                    placeholder="#fff"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.currentTarget.blur();
                      }
                    }}
                    onBlur={() => {
                      const formattedHex = formatHex(secondaryColor, true);
                      if (!validateHex(formattedHex)) {
                        setSecondaryColor(customPalette.secondaryButton);
                        setDisplayedSecondaryColor(
                          customPalette.secondaryButton
                        );
                        return;
                      }
                      setSecondaryColor(formattedHex);
                      setDisplayedSecondaryColor(formattedHex);
                    }}
                  />
                </div>
              </div>
              <div className="nav-sidebar__custom-color-input-row">
                <span className="nav-sidebar__custom-color-input-row-label">
                  Accent
                </span>
                <div className="nav-sidebar__custom-color-input-item">
                  <span
                    className="nav-sidebar__custom-color-preview"
                    style={{
                      backgroundColor: displayedAccentColor,
                    }}
                  />
                  <Input
                    value={accentColor}
                    onChange={(e) => setAccentColor(e.target.value)}
                    size="small"
                    placeholder="#fff"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.currentTarget.blur();
                      }
                    }}
                    onBlur={() => {
                      const formattedHex = formatHex(accentColor, true);
                      if (!validateHex(formattedHex)) {
                        setAccentColor(customPalette.accent);
                        setDisplayedAccentColor(customPalette.accent);
                        return;
                      }
                      setAccentColor(formattedHex);
                      setDisplayedAccentColor(formattedHex);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        onConfirm={handleOnConfirm}
        okText="Apply"
        cancelText="Cancel"
        onCancel={() => {
          setPrimaryColor(customPalette.primaryButton);
          setDisplayedPrimaryColor(customPalette.primaryButton);
          setSecondaryColor(customPalette.secondaryButton);
          setDisplayedSecondaryColor(customPalette.secondaryButton);
          setAccentColor(customPalette.accent);
          setDisplayedAccentColor(customPalette.accent);
        }}
      >
        <button
          className={classNames("nav-sidebar__theme-item", {
            "is-active": customPalette.isCustomPaletteActivated,
            "is-disabled":
              props.websites.isWaitingForChangeColorPaletteServerResponse,
            "is-loading": isLoading,
          })}
        >
          {isLoading && <LoaderAnimated />}
          {!isLoading && "Custom"}
        </button>
      </Popconfirm>
    </div>
  );
};

interface FontSelectorProps extends Props {}
const FontSelector = (props: FontSelectorProps) => {
  const { currentWebsite } = props.getCurrentStoreData();
  const [isLoading, setIsLoading] = useState(false);
  const isCustomFontActive =
    _.get(currentWebsite, "active_font_classname") ===
    googleFontsEnabledClassname;
  const customFontsSet: any = _.get(currentWebsite, "custom_fonts_set", {});
  const [titleFontFamily, setTitleFontFamily] = useState(
    customFontsSet.title || "Roboto"
  );
  const [textFontFamily, setTextFontFamily] = useState(
    customFontsSet.text || "Roboto"
  );

  const handleOnConfirm = () => {
    const newFontsSet = {
      title: titleFontFamily,
      text: textFontFamily,
    };
    setIsLoading(true);
    props.toggleWaitingForResponseOnFontChange(true);
    updateWebsiteAsync({
      accessToken: props.auth.accessToken,
      subdomain: _.get(currentWebsite, "subdomain"),
      data: {
        custom_fonts_set: newFontsSet,
        active_font_classname: googleFontsEnabledClassname,
      },
    })
      .then(() => {
        const dataToStore = {
          data: {
            ...currentWebsite,
            custom_fonts_set: newFontsSet,
            active_font_classname: googleFontsEnabledClassname,
          },
        };
        props.saveWebsiteDataInStore(
          dataToStore,
          _.get(currentWebsite, "subdomain")
        );
      })
      .catch((error) => {
        console.error(error.response);
        openNotification(
          DEFAULT_ERROR_TITLE,
          DEFAULT_ERROR_MESSAGE,
          "OK",
          "error",
          notificationDuration.medium
        );
      })
      .finally(() => {
        setIsLoading(false);
        props.toggleWaitingForResponseOnFontChange(false);
      });
  };

  return (
    <div className="comps nav-sidebar__theme">
      {websiteFontOptions.map((item: any, key: number) => {
        return (
          <FontOptionItem
            fontClassname={item.fontClassname}
            fontTitle={item.fontTitle}
            fontInfo={item.fontInfo}
            key={key}
            saveWebsiteDataInStore={props.saveWebsiteDataInStore}
            item={item}
          />
        );
      })}
      <Popconfirm
        overlayStyle={{
          position: "fixed",
          width: "280px",
        }}
        placement="rightBottom"
        overlayClassName="nav-sidebar__custom-color"
        align={{ offset: [-32, -16] }}
        icon={null}
        disabled={props.websites.isWaitingForChangeFontServerResponse}
        title={
          <div className="nav-sidebar__custom-fonts-wrapper">
            <div className="nav-sidebar__custom-fonts-item">
              <span
                className="nav-sidebar__custom-fonts-item-label apply-font-title"
                style={{
                  fontWeight: 600,
                }}
              >
                Titles
              </span>
              <FontPicker
                onChange={(nextFont) => {
                  setTitleFontFamily(nextFont.family);
                }}
                activeFontFamily={titleFontFamily}
                apiKey={googleFontsAPIkey}
                variants={["700"]}
                limit={200}
                pickerId="title"
              />
            </div>
            <div className="nav-sidebar__custom-fonts-item">
              <span
                className="nav-sidebar__custom-fonts-item-label apply-font-text"
                style={{
                  fontWeight: 400,
                }}
              >
                Text
              </span>
              <FontPicker
                onChange={(nextFont) => {
                  setTextFontFamily(nextFont.family);
                }}
                activeFontFamily={textFontFamily}
                apiKey={googleFontsAPIkey}
                variants={["regular"]}
                limit={200}
                pickerId="text"
              />
            </div>
          </div>
        }
        onConfirm={handleOnConfirm}
        onCancel={() => {
          setTitleFontFamily(customFontsSet.title || "Roboto");
          setTextFontFamily(customFontsSet.text || "Roboto");
        }}
        okText="Apply"
        cancelText="Cancel"
      >
        <button
          className={classNames("nav-sidebar__theme-item", {
            "is-active": isCustomFontActive,
            "is-disabled": props.websites.isWaitingForChangeFontServerResponse,
            "is-loading": isLoading,
          })}
        >
          {isLoading && <LoaderAnimated />}
          {!isLoading && "Custom"}
        </button>
      </Popconfirm>
    </div>
  );
};

interface ThemeMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  scrollToTop: () => void;
}
const ThemeMenu = (props: ThemeMenuProps) => {
  const { setSidebarMenu, sidebarMenu, scrollToTop } = props;
  const { currentWebsite } = props.getCurrentStoreData();
  const handleOnReturn = () => {
    scrollToTop();
    setSidebarMenu("website");
  };
  const hasUnsavedChanges =
    currentWebsite && _.get(currentWebsite, "hasUnsavedChanges");
  return (
    <>
      <div className="nav-sidebar__fixed-navigation is-single">
        <UnsavedChangesPopconfirm
          disabled={!hasUnsavedChanges}
          onDiscard={handleOnReturn}
        >
          <SidebarButton
            onClick={() => {
              if (hasUnsavedChanges) return;
              handleOnReturn();
            }}
            icon={<ArrowLeft size={16} />}
          >
            Theme
          </SidebarButton>
        </UnsavedChangesPopconfirm>
      </div>
      <div className="nav-sidebar__menu-container comps">
        <SidebarMenuWrapper title="Colors">
          <ColorsSelector {...props} />
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Fonts">
          <FontSelector {...props} />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "24px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Buttons">
          <ButtonStyleMenu />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "22px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Font size">
          <FontSizeMenu />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "22px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Inputs">
          <InputStyleMenu />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "22px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Cards">
          <CardStyleMenu />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "22px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Spacing">
          <ContainerStyleMenu />
          <div style={{ padding: "0 8px" }}>
            <Divider style={{ margin: "22px 0 0" }} />
          </div>
        </SidebarMenuWrapper>
        <SidebarMenuWrapper title="Custom CSS">
          <CustomCssStyleMenu />
        </SidebarMenuWrapper>
        <SaveChangesButtons />
      </div>
    </>
  );
};

interface BlogPostContextDropdownProps extends Props {
  children: React.ReactNode;
  blogPost: BlogPostItem;
  setSettingsModalType: (type: string) => void;
}
const BlogPostContextDropdown = (props: BlogPostContextDropdownProps) => {
  const {
    children,
    blogPost,
    getCurrentStoreData,
    websites,
    blogs,
    blogPosts,
    setIsSettingsModalVisible,
    setSettingsModalType,
  } = props;
  const { currentWebsitePage, currentWebsite, currentBlogPost, currentBlog } =
    getCurrentStoreData();
  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
  const {
    isWaitingForCloneBlogPostResponse,
    isWaitingForDeleteBlogPostResponse,
  } = blogPosts;
  const [visible, setVisible] = useState(false);
  const currentPostBlog = blogs.items.find((blog) => blog.id === blogPost.blog);
  const currentPostWebsite = websites.items.find(
    (website) => website.id === currentPostBlog.website
  );

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag);
    if (!flag) {
      setIsDeleteConfirmVisible(false);
    }
  };
  const handleOnDeleteClick = (e) => {
    if (!isDeleteConfirmVisible) {
      setIsDeleteConfirmVisible(true);
    }
  };
  const handleOnMenuClick = (e) => {
    e.domEvent.stopPropagation();
  };

  const handleOnDuplicatePost = () => {
    props.duplicatePost(blogPost).then((data) => {
      props.history.push(`/${currentPostWebsite.subdomain}/blog/${data.id}`);
      window.scrollTo(0, 0);
      setVisible(false);
    });
  };

  const handleOnDeletePost = () => {
    props.deletePost(blogPost).then((response) => {
      if (currentBlogPost === blogPost) {
        props.history.push(`/${currentPostWebsite.subdomain}/blog`);
        window.scrollTo(0, 0);
      }
    });
  };

  const openPostSettings = () => {
    if (_.get(currentBlogPost, "id") !== blogPost.id) {
      props.history.push(
        `/${currentPostWebsite.subdomain}/blog/${blogPost.id}`
      );
      window.scrollTo(0, 0);
    }
    setTimeout(() => {
      setSettingsModalType("post");
      setIsSettingsModalVisible(true);
      setVisible(false);
    }, 0);
  };

  const menu = (
    <Menu className="nav-sidebar__dropdown-menu" onClick={handleOnMenuClick}>
      <Menu.Item
        key="preview"
        className="nav-sidebar__dropdown-item"
        onClick={() => {
          if (blogPost.status !== "draft") {
            props.previewPost(blogPost.id);
            setVisible(false);
            return;
          }
          props.publishPost(
            "public",
            currentWebsite,
            currentBlog,
            blogPost,
            () => {
              props.previewPost(blogPost.id);
              setVisible(false);
            }
          );
        }}
        disabled={blogPosts.isWaitingForPublishPostResponse}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            {!blogPosts.isWaitingForPublishPostResponse && (
              <ExternalLink size={16} />
            )}
            {blogPosts.isWaitingForPublishPostResponse && <LoaderAnimated />}
          </div>
          <span className="nav-sidebar__dropdown-item-name">
            {blogPost.status === "draft" ? "Publish & Preview" : "Preview"}
          </span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="settings"
        className="nav-sidebar__dropdown-item"
        onClick={openPostSettings}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            <Settings size={16} />
          </div>
          <span className="nav-sidebar__dropdown-item-name">Settings</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="duplicate"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForCloneBlogPostResponse}
        onClick={handleOnDuplicatePost}
      >
        <div className="nav-sidebar__dropdown-item-inner">
          <div className="nav-sidebar__dropdown-item-icon">
            {!isWaitingForCloneBlogPostResponse && <Copy size={16} />}
            {isWaitingForCloneBlogPostResponse && <LoaderAnimated />}
          </div>
          <span className="nav-sidebar__dropdown-item-name">Duplicate</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="delete"
        className="nav-sidebar__dropdown-item"
        disabled={isWaitingForDeleteBlogPostResponse}
        onClick={handleOnDeleteClick}
      >
        {!isDeleteConfirmVisible && (
          <div className="nav-sidebar__dropdown-item-inner">
            <div className="nav-sidebar__dropdown-item-icon">
              <Trash2 size={16} />
            </div>
            <span className="nav-sidebar__dropdown-item-name">Delete</span>
          </div>
        )}
        {isDeleteConfirmVisible && (
          <DeleteButtons
            loading={isWaitingForDeleteBlogPostResponse}
            deleteAction={handleOnDeletePost}
            deleteItemTitle={"blog post"}
            cancelAction={() => {
              setIsDeleteConfirmVisible(false);
            }}
          />
        )}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="nav-sidebar__dropdown-overlay is-context"
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      {children}
    </Dropdown>
  );
};

interface BlogMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  setSettingsModalType: (type: string) => void;
  scrollToTop: () => void;
}
const BlogMenu = (props: BlogMenuProps) => {
  const {
    blogPosts,
    setSidebarMenu,
    sidebarMenu,
    setIsSettingsModalVisible,
    setSettingsModalType,
    scrollToTop,
  } = props;
  const { currentBlog, currentWebsite, currentBlogPost } =
    props.getCurrentStoreData();
  const { isWaitingForCreateBlogPostResponse } = blogPosts;
  const [searchValue, setSearchValue] = useState("");

  const loaderJsx = (
    <div>
      <SidebarMenuWrapper>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            padding: "0 8px",
          }}
        >
          <SidebarSkeletonLoader hasIcon width="120px" />
          <SidebarSkeletonLoader hasIcon width="85px" />
          <SidebarSkeletonLoader hasIcon width="140px" />
          <SidebarSkeletonLoader hasIcon width="110px" />
          <SidebarSkeletonLoader hasIcon width="95px" />
          <SidebarSkeletonLoader hasIcon width="130px" />
          <SidebarSkeletonLoader hasIcon width="100px" />
          <SidebarSkeletonLoader hasIcon width="115px" />
          <SidebarSkeletonLoader hasIcon width="90px" />
          <SidebarSkeletonLoader hasIcon width="125px" />
        </div>
      </SidebarMenuWrapper>
    </div>
  );

  const isLoading =
    props.getInitialPostsStatus(currentBlog) !== LoadStatus.LOADED;

  const createPost = async () => {
    props.createAndSavePost().then(({ postData, currentBlog }) => {
      props.history.push(
        `/${_.get(currentWebsite, "subdomain")}/blog/${postData.id}`
      );
      window.scrollTo(0, 0);
    });
  };
  const handleOnClickBlogPost = (postId: number) => {
    props.history.push(`/${_.get(currentWebsite, "subdomain")}/blog/${postId}`);
    window.scrollTo(0, 0);
  };

  const mapPostsFn = (blogPost) => {
    const displayedTitle = blogPost.title || `/${blogPost.url}`;
    const isSelected = _.get(currentBlogPost, "id") === blogPost.id;
    const iconStyle = {
      opacity: blogPost.status !== "draft" ? 1 : 0.5,
    };
    return (
      <SidebarButton
        tooltip={
          <div className="nav-sidebar__button-tooltip-content">
            <div className="nav-sidebar__button-tooltip-title">
              {blogPost.title || `/${blogPost.url}`}
            </div>
            <div className="nav-sidebar__button-tooltip-subtitle">
              {blogPost.status === "draft"
                ? "Draft"
                : blogPost.status === "direct_url"
                ? "Direct URL"
                : "Published"}
            </div>
          </div>
        }
        key={blogPost.url}
        icon={<FileText size={16} style={iconStyle} />}
        contextButton={
          _.get(blogPost, "is_seobot_post") ? null : (
            <BlogPostContextDropdown
              {...props}
              blogPost={blogPost}
              setSettingsModalType={setSettingsModalType}
            >
              <span
                className="nav-sidebar__button-context-button"
                onClick={(e) => e.stopPropagation()}
              >
                <Ellipsis size={16} />
              </span>
            </BlogPostContextDropdown>
          )
        }
        isSelected={isSelected}
        onClick={() => {
          handleOnClickBlogPost(blogPost.id);
        }}
      >
        <span>{displayedTitle}</span>
      </SidebarButton>
    );
  };

  let posts = [...blogPosts.items]
    .filter((blogPost) => {
      if (!currentBlog) return false;
      return blogPost.blog === _.get(currentBlog, "id");
    })
    .map((post) => {
      (post as any).search_query_string = post.title || post.url;
      return post;
    });

  if (!searchValue) {
    posts = posts.sort(sortByDateFn);
  } else {
    posts = fuzzysort
      .go(searchValue, posts, {
        keys: ["search_query_string"],
      })
      .map((result) => {
        const { obj } = result as any;
        return obj;
      });
  }

  const nativePosts = posts.filter((post) => {
    return !post.is_seobot_post;
  });
  const seobotPosts = posts.filter((post) => {
    return post.is_seobot_post;
  });
  const displayedNativePosts = nativePosts.map(mapPostsFn);
  const displayedSeobotPosts = seobotPosts.map(mapPostsFn);

  const totalPosts = _.get(blogPosts, "items", []).filter(
    (post) => post.blog === _.get(currentBlog, "id")
  ).length;
  const blogHasNoPosts = totalPosts === 0;

  return (
    <>
      <div className="nav-sidebar__fixed-navigation">
        <SidebarButton
          onClick={() => {
            props.history.push(`/${_.get(currentWebsite, "subdomain")}/pages`);
            window.scrollTo(0, 0);
            scrollToTop();
            setSidebarMenu("website");
          }}
          icon={<ArrowLeft size={16} />}
          additionalActionOnClick={createPost}
          isAdditionalActionLoading={isWaitingForCreateBlogPostResponse}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            Blog
            {!isWaitingForCreateBlogPostResponse && (
              <span
                style={{ lineHeight: 0, position: "absolute", right: 32 }}
                className="nav-sidebar__button-context-button is-additional-action"
                onClick={(e) => {
                  e.stopPropagation();
                  props.setUserStateData({
                    settings: "blogSettings",
                  });
                  setSettingsModalType("website");
                  setIsSettingsModalVisible(true);
                }}
              >
                <Settings size={16} />
              </span>
            )}
          </span>
        </SidebarButton>
        {!blogHasNoPosts && !isLoading && (
          <div className="nav-sidebar__search">
            <DebouncedInput
              prefix={<Search size={14} />}
              placeholder="Search..."
              debounceDelay={250}
              className="nav-sidebar__search-input"
              onChange={(value) => {
                setSearchValue(value);
              }}
              value={searchValue}
            />
          </div>
        )}
      </div>
      {!!currentWebsite && currentBlog && (
        <>
          <div className="nav-sidebar__menu-container">
            {isLoading && loaderJsx}
            {!isLoading && (
              <SidebarMenuWrapper
                title={displayedSeobotPosts.length > 0 ? "Blog posts" : null}
              >
                {displayedNativePosts}
                {blogHasNoPosts && (
                  <Empty
                    description="No blog posts yet"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ margin: 0, marginTop: 16 }}
                  />
                )}
              </SidebarMenuWrapper>
            )}
            {!isLoading && displayedSeobotPosts.length > 0 && (
              <SidebarMenuWrapper title="Seobot posts">
                {displayedSeobotPosts}
              </SidebarMenuWrapper>
            )}
            {!isLoading &&
              !blogHasNoPosts &&
              !!searchValue &&
              posts.length === 0 && (
                <div>
                  <Empty
                    description="No results"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ margin: 0, marginTop: 16 }}
                  />
                </div>
              )}
          </div>
        </>
      )}
    </>
  );
};

interface WebsiteSelectorProps extends Props {
  setSidebarMenu: (menu: string) => void;
  scrollToTop: () => void;
  onClickPath?: string;
  hideSearch?: boolean;
}
const WebsiteSelector = (props: WebsiteSelectorProps) => {
  const {
    websites,
    user,
    getCurrentStoreData,
    history,
    setSidebarMenu,
    setIsSearchModalVisible,
    scrollToTop,
    onClickPath,
    hideSearch,
  } = props;
  const { currentWebsite } = getCurrentStoreData();
  const userId = _.get(user, "data.id");
  const [visible, setVisible] = useState(false);
  const [isWebsiteModalVisible, setIsWebsiteModalVisible] = useState(false);
  const searchInputRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (props.user.isSearchModalVisible) {
      setVisible(false);
    }
  }, [props.user.isSearchModalVisible]);

  useEffect(() => {
    if (visible) {
      if (searchInputRef.current && searchInputRef.current.focus) {
        setTimeout(() => {
          searchInputRef.current.focus();
        }, 0);
      }
    }
    if (!visible) {
      setSearchValue("");
    }
  }, [visible]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setIsSearchModalVisible(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const ownedWebsites = websites.items.filter(
    (website) => website.owner === userId
  );
  const sharedWebsites = websites.items.filter(
    (website) => website.owner !== userId
  );

  const getIcon = (website, iconAlwaysVisible?: boolean) => {
    if (!website) return null;
    const initialPagesStatus = props.getWebsiteInitialPagesLoadStatus(website);
    const isPublished = iconAlwaysVisible
      ? true
      : initialPagesStatus !== LoadStatus.LOADED
      ? website.is_published
      : checkIsWebsitePublished(website, props.websitesPages.items);
    const faviconUrl = _.get(website, "favicon_16x16_url");
    if (faviconUrl) {
      return (
        <img
          src={formatImageUrl(faviconUrl)}
          style={{
            width: "16px",
            height: "16px",
            objectFit: "contain",
            opacity: isPublished ? 1 : 0.25,
          }}
        />
      );
    }
    return <Globe size={16} style={{ opacity: isPublished ? 1 : 0.5 }} />;
  };

  const handleItemOnClick = (website) => {
    scrollToTop();
    history.push(`/${website.subdomain}${onClickPath ? onClickPath : ""}`);
    window.scrollTo(0, 0);
    setVisible(false);
  };

  const mapWebsitesFn = (website) => {
    const isPublished =
      props.getWebsiteInitialPagesLoadStatus(website) !== LoadStatus.LOADED
        ? website.is_published
        : checkIsWebsitePublished(website, props.websitesPages.items);
    return (
      <Menu.Item
        key={website.subdomain}
        className="nav-sidebar__dropdown-item"
        onClick={(e) => {
          handleItemOnClick(website);
        }}
      >
        <Tooltip
          title={
            <div className="nav-sidebar__button-tooltip-content">
              <div className="nav-sidebar__button-tooltip-title">
                {getActiveDomain(website)}
              </div>
              <div className="nav-sidebar__button-tooltip-subtitle">
                {isPublished ? "Published" : "Not published"}
              </div>
            </div>
          }
          placement="right"
          mouseLeaveDelay={0}
          mouseEnterDelay={0.5}
          transitionName=""
          overlayClassName="nav-sidebar__button-tooltip"
        >
          <div className="nav-sidebar__dropdown-item-inner">
            <div className="nav-sidebar__dropdown-item-icon">
              {getIcon(website)}
            </div>
            <span className="nav-sidebar__dropdown-item-name">
              {getActiveDomain(website)}
            </span>
          </div>
        </Tooltip>
        <WebsiteContextDropdown {...props} website={website}>
          <button
            className="nav-sidebar__dropdown-context-button"
            onClick={(e) => e.stopPropagation()}
          >
            <Ellipsis size={16} />
          </button>
        </WebsiteContextDropdown>
      </Menu.Item>
    );
  };

  let allSites = [...ownedWebsites, ...sharedWebsites].map((website) => {
    (website as any).search_query_string = getActiveDomain(website);
    return website;
  });
  const hasSearch = allSites.length > 3;
  if (searchValue) {
    allSites = fuzzysort
      .go(searchValue, allSites, {
        keys: ["search_query_string"],
      })
      .map((result) => {
        const { obj } = result as any;
        return obj;
      });
  }

  const selectedKey = _.get(currentWebsite, "subdomain");
  const menu = (
    <Menu selectedKeys={[selectedKey]} className="nav-sidebar__dropdown-menu">
      {hasSearch && (
        <Menu.Item disabled className="nav-sidebar__dropdown-search">
          <div className="nav-sidebar__dropdown-search-box">
            <DebouncedInput
              inputRef={searchInputRef}
              prefix={<Search size={16} />}
              placeholder="Search..."
              debounceDelay={250}
              onChange={(value) => {
                setSearchValue(value);
              }}
              defaultValue={searchValue}
              autoFocus
            />
          </div>
        </Menu.Item>
      )}
      {!!searchValue && allSites.map(mapWebsitesFn)}
      {!!searchValue && allSites.length === 0 && (
        <Menu.Item disabled className="nav-sidebar__dropdown-search-empty">
          <Empty
            description="No results"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </Menu.Item>
      )}
      {ownedWebsites.length > 0 && !searchValue && (
        <Menu.Item
          disabled
          className="nav-sidebar__dropdown-subtitle"
          style={{ marginTop: 4, marginBottom: -4 }}
        >
          Your websites
        </Menu.Item>
      )}
      {!searchValue && ownedWebsites.sort(sortByDateFn).map(mapWebsitesFn)}
      {sharedWebsites.length > 0 && !searchValue && (
        <Menu.Item
          disabled
          className="nav-sidebar__dropdown-subtitle"
          style={{ marginTop: 4, marginBottom: -4 }}
        >
          Shared with you
        </Menu.Item>
      )}
      {!searchValue && sharedWebsites.sort(sortByDateFn).map(mapWebsitesFn)}
      <Menu.Item disabled className="nav-sidebar__dropdown-cta-container">
        <CtaButton
          onClick={() => {
            setIsWebsiteModalVisible(true);
            setVisible(false);
          }}
        >
          Create website
        </CtaButton>
      </Menu.Item>
    </Menu>
  );

  const onSubmit = (event, templateSubdomain?, templateWebsiteId?) => {
    props.createWebsiteFromTemplate({
      event,
      templateSubdomain,
      templateWebsiteId,
      newWebsiteSubdomain: generateRandomSubdomain().toString(),
      hideForm: () => {
        setIsWebsiteModalVisible(false);
      },
      history,
    });
  };

  return (
    <div>
      <Dropdown
        trigger={["click"]}
        overlay={menu}
        className={classNames("nav-sidebar__dropdown", {
          "has-search": !hideSearch,
        })}
        overlayClassName={classNames(
          "nav-sidebar__dropdown-overlay is-website-selector",
          {
            "has-search": hasSearch,
          }
        )}
        onVisibleChange={setVisible}
        visible={visible}
      >
        <div className="nav-sidebar__dropdown-wrapper">
          <div className="nav-sidebar__dropdown-button">
            {!!currentWebsite && getIcon(currentWebsite, true)}
            <div className="nav-sidebar__dropdown-button-text">
              {!!currentWebsite
                ? getActiveDomain(currentWebsite, null, true)
                : "Websites"}
            </div>
          </div>
          <ChevronDown size={16} />
          {!hideSearch && (
            <button
              className="nav-sidebar__dropdown-search-button"
              onClick={(e) => {
                e.stopPropagation();
                setIsSearchModalVisible(true);
              }}
            >
              <Search size={16} />
            </button>
          )}
        </div>
      </Dropdown>
      <CreateNewWebsiteModal
        isFormVisible={isWebsiteModalVisible}
        onSubmit={onSubmit}
        hideForm={() => {
          setIsWebsiteModalVisible(false);
        }}
        title={"Create a new website 🦄"}
        name={"subdomain"}
        labelText={"Enter a subdomain:"}
        placeholder={"pied-piper"}
        errors={websites.createWebsiteErrorMessage}
        isLoading={websites.isWaitingForCreateWebsiteResponse}
        classNameForCreateButton={"js-tour__create-new-site__button"}
      />
    </div>
  );
};

interface TopButtonsProps extends Props {
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  setSettingsModalType: (type: string) => void;
  scrollToTop: () => void;
}
const TopButtons = (props: TopButtonsProps) => {
  const {
    setSidebarMenu,
    sidebarMenu,
    setIsSearchModalVisible,
    setIsSettingsModalVisible,
    setSettingsModalType,
    scrollToTop,
  } = props;

  const loaderJsx = (
    <div className="nav-sidebar__top-buttons">
      <SidebarMenuWrapper>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            padding: "0 8px",
          }}
        >
          <SidebarSkeletonLoader width="120px" />
          <SidebarSkeletonLoader width="85px" />
        </div>
      </SidebarMenuWrapper>
    </div>
  );

  if (
    !props.websites.dataFetched ||
    !props.user.dataFetched ||
    !props.plans.dataFetched
  ) {
    return loaderJsx;
  }

  const { currentWebsite, currentBlog } = props.getCurrentStoreData();

  if (!currentWebsite) {
    return null;
  }

  const singleWebsiteStatus = props.getSingleWebsiteLoadStatus(currentWebsite);
  if (singleWebsiteStatus !== LoadStatus.LOADED) {
    return loaderJsx;
  }

  const singleBlogStatus = props.getSingleBlogLoadStatus(currentBlog);
  if (singleBlogStatus !== LoadStatus.LOADED) {
    return loaderJsx;
  }

  return (
    <div className="nav-sidebar__top-buttons">
      <SidebarMenuWrapper>
        <DuePaymentAlert />

        <SidebarButton
          onClick={() => {
            setSettingsModalType("website");
            setIsSettingsModalVisible(true);
          }}
          icon={<Settings size={16} />}
        >
          Settings
        </SidebarButton>

        <SidebarButton
          onClick={() => {
            const pathArray = props.history.location.pathname
              .split("/")
              .filter((i) => !!i);
            if (pathArray[1] !== "pages") {
              props.history.push(
                `/${_.get(currentWebsite, "subdomain")}/pages`
              );
              window.scrollTo(0, 0);
            }
            scrollToTop();
            setSidebarMenu("theme");
          }}
          icon={<Palette size={16} />}
        >
          Theme
        </SidebarButton>
      </SidebarMenuWrapper>
    </div>
  );
};

interface PageTemplatesMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  scrollToTop: () => void;
}
const PageTemplatesMenu = (props: PageTemplatesMenuProps) => {
  const { setSidebarMenu, websitesPages, getCurrentStoreData, scrollToTop } =
    props;
  const { currentWebsite } = getCurrentStoreData();
  const currentWebsitePages = websitesPages.items.filter((page) => {
    return page.website === _.get(currentWebsite, "id");
  });
  const [searchValue, setSearchValue] = useState("");
  return (
    <>
      <div className="nav-sidebar__fixed-navigation">
        <SidebarButton
          onClick={() => {
            scrollToTop();
            setSidebarMenu("website");
          }}
          icon={<ArrowLeft size={16} />}
        >
          Add page
        </SidebarButton>
        <div className="nav-sidebar__search">
          <DebouncedInput
            prefix={<Search size={14} />}
            placeholder="Search..."
            debounceDelay={250}
            className="nav-sidebar__search-input"
            onChange={(value) => {
              setSearchValue(value);
            }}
            defaultValue={searchValue}
            autoFocus
          />
        </div>
      </div>
      <div className="nav-sidebar__menu-container space-large comps">
        <SidebarMenuWrapper>
          <PageTemplatesList
            currentWebsitePages={currentWebsitePages}
            onSuccess={() => {
              setSidebarMenu("website");
            }}
            setSidebarMenu={setSidebarMenu}
            searchValue={searchValue}
          />
        </SidebarMenuWrapper>
      </div>
    </>
  );
};

interface AgentItemProps {
  name?: string;
  color?: string;
  onClick?: () => void;
  isSelected?: boolean;
  avatar?: string;
  children?: React.ReactNode;
  hasBorder?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
}
const AgentItem = (props: AgentItemProps) => {
  return (
    <Tooltip
      title={
        <div className="nav-sidebar__button-tooltip-content">
          <div className="nav-sidebar__button-tooltip-title">
            {props.disabled && props.disabledMessage
              ? props.disabledMessage
              : props.name}
          </div>
        </div>
      }
      placement="right"
      mouseLeaveDelay={0}
      mouseEnterDelay={0.1}
      transitionName=""
      overlayClassName="nav-sidebar__button-tooltip"
    >
      <div
        className={classNames("nav-sidebar__agents-item", {
          "is-selected": props.isSelected,
          "has-image": !!props.avatar,
          "has-border": props.hasBorder,
          "is-disabled": props.disabled,
        })}
        style={{ backgroundColor: props.color }}
        onClick={() => {
          if (props.disabled) return;
          if (!props.onClick) return;
          props.onClick();
        }}
      >
        {!!props.avatar && <img src={props.avatar} />}
        {props.children}
      </div>
    </Tooltip>
  );
};

interface AgentsMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  sidebarMenu: string;
  selectedAgent: string;
  setSelectedAgent: (agent: string) => void;
  scrollToTop: () => void;
}
const AgentsMenu = (props: AgentsMenuProps) => {
  const {
    setSidebarMenu,
    sidebarMenu,
    selectedAgent,
    setSelectedAgent,
    scrollToTop,
  } = props;
  const { currentWebsite } = props.getCurrentStoreData();
  const hasUnsavedChanges =
    currentWebsite && _.get(currentWebsite, "hasUnsavedChanges");

  const pathArray = getPathArray(props.history.location.pathname);
  const currentAppSection = pathArray[1];
  const currentAgentId = pathArray[2];
  const currentAgent = props.getCurrentAgent();

  const goToSite = () => {
    const pathhistoryLs = localStorage.getItem(PATH_HISTORY_LS_KEY);
    let path = `/${_.get(currentWebsite, "subdomain")}`;

    if (currentAppSection === "analytics") {
      path = `/${_.get(currentWebsite, "subdomain")}`;
    } else if (
      validatePath({
        path: pathhistoryLs,
        websites: props.websites,
      })
    ) {
      path = pathhistoryLs;
    }
    props.history.push(path);
    window.scrollTo(0, 0);
  };

  const handleOnWebdevClick = () => {
    scrollToTop();
    setSidebarMenu("website");
    if (selectedAgent === "web_dev") {
      props.history.push(`/${_.get(currentWebsite, "subdomain")}`);
      window.scrollTo(0, 0);
      props.incrementNavSidebarKey();
      props.incrementEditorKey();
    }
    setSelectedAgent("web_dev");
    goToSite();
  };
  const handleOnDataClick = () => {
    scrollToTop();
    setSelectedAgent("data");
    setSidebarMenu("website");
    props.history.push(`/${_.get(currentWebsite, "subdomain")}/cms`);
    window.scrollTo(0, 0);
  };
  const handleOnAnalyticsClick = () => {
    scrollToTop();
    setSelectedAgent("analytics");
    setSidebarMenu("analytics");
    props.history.push(`/${_.get(currentWebsite, "subdomain")}/analytics`);
    window.scrollTo(0, 0);
  };
  const handleOnHireClick = () => {
    setSidebarMenu("hire");
    props.history.push(`/${_.get(currentWebsite, "subdomain")}/manage_agent`);
    window.scrollTo(0, 0);
  };

  const agentsJson = _.get(props.meta, "items.0.agents.items", []);
  const websiteAgentsData = _.get(currentWebsite, "agents_data.items", []);

  const installedAgents = agentsJson
    .filter((agent) => {
      return websiteAgentsData.find((websiteAgent) => {
        return websiteAgent.id === agent.id;
      });
    })
    .sort((a, b) => {
      const aData = props.getAgentInstallData(a.id);
      const bData = props.getAgentInstallData(b.id);
      if (aData && bData) {
        return bData.installed_at - aData.installed_at;
      }
      return 0;
    });

  let isAllAgentsDisabled = false;
  let disabledMessage = "Agent not available";
  const { isAvailable, message } = props.checkIfAgentsAvailable();
  if (!isAvailable) {
    isAllAgentsDisabled = true;
    disabledMessage = message;
  }

  const installedAgentsJsx = installedAgents.map((agent) => {
    const handleOnAgentClick = () => {
      props.history.push(
        `/${_.get(currentWebsite, "subdomain")}/agents/${agent.id}`
      );
      window.scrollTo(0, 0);
    };
    return (
      <UnsavedChangesPopconfirm
        disabled={!hasUnsavedChanges}
        onDiscard={handleOnAgentClick}
        placement="right"
        key={agent.id}
      >
        <AgentItem
          color={agent.logoBgColor}
          name={agent.title}
          onClick={() => {
            if (hasUnsavedChanges) return;
            handleOnAgentClick();
          }}
          avatar={agent.logo}
          isSelected={
            currentAppSection === "agents" &&
            currentAgent &&
            currentAgent.isInstalled &&
            currentAgent.agentData.id === agent.id
          }
          disabled={!agent.isAvailable || isAllAgentsDisabled}
          disabledMessage={disabledMessage}
        ></AgentItem>
      </UnsavedChangesPopconfirm>
    );
  });

  const isMetaLoaded = _.get(props.meta, "dataFetched");

  return (
    <div className="nav-sidebar__agents-menu">
      <UnsavedChangesPopconfirm
        disabled={!hasUnsavedChanges}
        onDiscard={handleOnWebdevClick}
        placement="right"
      >
        <AgentItem
          color="#747d8c"
          name="Web dev agent"
          isSelected={
            currentAppSection === "pages" ||
            currentAppSection === "blog" ||
            !currentAppSection
          }
          onClick={() => {
            if (hasUnsavedChanges) return;
            handleOnWebdevClick();
          }}
        >
          <Blocks size={16} />
        </AgentItem>
      </UnsavedChangesPopconfirm>
      <UnsavedChangesPopconfirm
        disabled={!hasUnsavedChanges}
        onDiscard={handleOnDataClick}
        placement="right"
      >
        <AgentItem
          color="#C8AEE5"
          name="Data agent"
          isSelected={currentAppSection === "cms"}
          onClick={() => {
            if (hasUnsavedChanges) return;
            handleOnDataClick();
          }}
        >
          <Database size={16} />
        </AgentItem>
      </UnsavedChangesPopconfirm>
      <UnsavedChangesPopconfirm
        disabled={!hasUnsavedChanges}
        onDiscard={handleOnAnalyticsClick}
        placement="right"
      >
        <AgentItem
          color="#90B8F8"
          name="Analytics agent"
          onClick={() => {
            if (hasUnsavedChanges) return;
            handleOnAnalyticsClick();
          }}
          isSelected={currentAppSection === "analytics"}
        >
          <ChartPie size={16} />
        </AgentItem>
      </UnsavedChangesPopconfirm>

      {isMetaLoaded && installedAgentsJsx}

      {isMetaLoaded && (
        <UnsavedChangesPopconfirm
          disabled={!hasUnsavedChanges}
          onDiscard={handleOnHireClick}
          placement="right"
        >
          <AgentItem
            color="#fff"
            name="Hire agent"
            onClick={() => {
              if (hasUnsavedChanges) return;
              handleOnHireClick();
            }}
            isSelected={currentAppSection === "manage_agent"}
            children={
              <span className="nav-sidebar__agents-item-icon">
                <Plus size={16} />
              </span>
            }
            hasBorder
          />
        </UnsavedChangesPopconfirm>
      )}

      {!isMetaLoaded && (
        <>
          <SidebarSkeletonLoader width="32px" height="32px" />
          <SidebarSkeletonLoader width="32px" height="32px" />
          <SidebarSkeletonLoader width="32px" height="32px" />
        </>
      )}
    </div>
  );
};

interface AnalyticsAgentMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  selectedAgent: string;
  setSelectedAgent: (agent: string) => void;
  scrollToTop: () => void;
}
const AnalyticsAgentMenu = (props: AnalyticsAgentMenuProps) => {
  const { setSidebarMenu, selectedAgent, setSelectedAgent, scrollToTop } =
    props;
  const currentAppSection = getPathArray(props.history.location.pathname)[1];
  return (
    <>
      <div
        className="nav-sidebar__fixed-navigation"
        style={{
          paddingBottom: 0,
        }}
      >
        <WebsiteSelector
          {...props}
          setSidebarMenu={setSidebarMenu}
          onClickPath={"/analytics"}
          hideSearch
        />
        <SidebarMenuWrapper title="Analytics">
          <SidebarButton isSelected icon={<ChartPie size={16} />}>
            Basic
          </SidebarButton>
          <SidebarButton
            icon={<ChartCandlestick size={16} />}
            onClick={() => {
              window.open(`https://countvisits.com/`, "_blank");
            }}
          >
            Advanced
          </SidebarButton>
        </SidebarMenuWrapper>
      </div>
    </>
  );
};

interface GrowthAgentMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  selectedAgent: string;
  setSelectedAgent: (agent: string) => void;
  scrollToTop: () => void;
}
const GrowthAgentMenu = (props: GrowthAgentMenuProps) => {
  const { setSidebarMenu, selectedAgent, setSelectedAgent, scrollToTop } =
    props;
  const pathArray = getPathArray(props.history.location.pathname);
  const currentAppSection = pathArray[1];
  const currentAgentType = pathArray[2];
  const currentAgent = pathArray[3];
  const { currentWebsite } = props.getCurrentStoreData();
  const agentsJson = _.get(props.meta, "items.0.agents", []);
  const isMetaLoaded = _.get(props.meta, "dataFetched");

  const buttons = agentsJson
    .filter((agent) => {
      return agent.type === "growth";
    })
    .map((agent) => {
      return (
        <SidebarButton
          onClick={() => {
            props.history.push(
              `/${_.get(currentWebsite, "subdomain")}/agents/growth/${
                agent.path
              }`
            );
          }}
          isSelected={
            currentAgentType === agent.type && currentAgent === agent.path
          }
          key={`${agent.type}-${agent.path}`}
          subtitle={agent.subtitle}
          disabled={!agent.available}
          tooltip={agent.available ? null : "Coming soon"}
        >
          {agent.displayedName}
        </SidebarButton>
      );
    });
  return (
    <>
      <div
        className="nav-sidebar__fixed-navigation"
        style={{
          paddingBottom: 0,
        }}
      >
        <WebsiteSelector
          {...props}
          setSidebarMenu={setSidebarMenu}
          onClickPath={`/agents/growth/${currentAgent}`}
          hideSearch
        />
        {isMetaLoaded && (
          <SidebarMenuWrapper gap={8}>{buttons}</SidebarMenuWrapper>
        )}
        {!isMetaLoaded && (
          <SidebarMenuWrapper>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
                padding: "0 8px",
              }}
            >
              <SidebarSkeletonLoader hasIcon width="120px" />
              <SidebarSkeletonLoader hasIcon width="85px" />
              <SidebarSkeletonLoader hasIcon width="140px" />
              <SidebarSkeletonLoader hasIcon width="110px" />
              <SidebarSkeletonLoader hasIcon width="95px" />
              <SidebarSkeletonLoader hasIcon width="130px" />
              <SidebarSkeletonLoader hasIcon width="100px" />
              <SidebarSkeletonLoader hasIcon width="115px" />
              <SidebarSkeletonLoader hasIcon width="90px" />
              <SidebarSkeletonLoader hasIcon width="125px" />
            </div>
          </SidebarMenuWrapper>
        )}
      </div>
    </>
  );
};

interface MonetizationAgentMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  selectedAgent: string;
  setSelectedAgent: (agent: string) => void;
  scrollToTop: () => void;
}
const MonetizationAgentMenu = (props: MonetizationAgentMenuProps) => {
  const { setSidebarMenu, selectedAgent, setSelectedAgent, scrollToTop } =
    props;
  const pathArray = getPathArray(props.history.location.pathname);
  const currentAppSection = pathArray[1];
  const currentAgentType = pathArray[2];
  const currentAgent = pathArray[3];
  const { currentWebsite } = props.getCurrentStoreData();
  const agentsJson = _.get(props.meta, "items.0.agents", []);
  const isMetaLoaded = _.get(props.meta, "dataFetched");
  const buttons = agentsJson
    .filter((agent) => {
      return agent.type === "monetization";
    })
    .map((agent) => {
      return (
        <SidebarButton
          onClick={() => {
            props.history.push(
              `/${_.get(currentWebsite, "subdomain")}/agents/monetization/${
                agent.path
              }`
            );
          }}
          isSelected={
            currentAgentType === agent.type && currentAgent === agent.path
          }
          key={`${agent.type}-${agent.path}`}
          subtitle={agent.subtitle}
          disabled={!agent.available}
          tooltip={agent.available ? null : "Coming soon"}
        >
          {agent.displayedName}
        </SidebarButton>
      );
    });
  return (
    <>
      <div
        className="nav-sidebar__fixed-navigation"
        style={{
          paddingBottom: 0,
        }}
      >
        <WebsiteSelector
          {...props}
          setSidebarMenu={setSidebarMenu}
          onClickPath={`/agents/monetization/${currentAgent}`}
          hideSearch
        />
        {isMetaLoaded && (
          <SidebarMenuWrapper gap={8}>{buttons}</SidebarMenuWrapper>
        )}
        {!isMetaLoaded && (
          <SidebarMenuWrapper>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
                padding: "0 8px",
              }}
            >
              <SidebarSkeletonLoader hasIcon width="120px" />
              <SidebarSkeletonLoader hasIcon width="85px" />
              <SidebarSkeletonLoader hasIcon width="140px" />
              <SidebarSkeletonLoader hasIcon width="110px" />
              <SidebarSkeletonLoader hasIcon width="95px" />
              <SidebarSkeletonLoader hasIcon width="130px" />
              <SidebarSkeletonLoader hasIcon width="100px" />
              <SidebarSkeletonLoader hasIcon width="115px" />
              <SidebarSkeletonLoader hasIcon width="90px" />
              <SidebarSkeletonLoader hasIcon width="125px" />
            </div>
          </SidebarMenuWrapper>
        )}
      </div>
    </>
  );
};

interface HireNewAgentMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  selectedAgent: string;
  setSelectedAgent: (agent: string) => void;
  scrollToTop: () => void;
}
const HireNewAgentMenu = (props: HireNewAgentMenuProps) => {
  const {
    setSidebarMenu,
    selectedAgent,
    setSelectedAgent,
    getCurrentStoreData,
    scrollToTop,
  } = props;
  const { currentWebsite } = getCurrentStoreData();
  const pathArray = getPathArray(props.history.location.pathname);
  const currentAppSection = pathArray[1];
  const agentsJson = _.get(props.meta, "items.0.agents.items", []);
  const websiteAgentsData = _.get(currentWebsite, "agents_data.items", []);

  const currentAgent = props.getCurrentAgent();

  const mapAgentsFn = (agent) => {
    return (
      <SidebarCard
        key={agent.id}
        iconSrc={agent.logo}
        title={agent.title}
        subtitle={agent.subtitle}
        onClick={() => {
          props.history.push(
            `/${_.get(currentWebsite, "subdomain")}/manage_agent/${agent.id}`
          );
        }}
        isSelected={
          currentAppSection === "manage_agent" &&
          !!currentAgent &&
          currentAgent.agentData.id === agent.id
        }
        isActive={!!props.getAgentInstallData(agent.id)}
        logoColor={agent.logoBgColor}
        isLocked={!agent.isAvailable}
      />
    );
  };

  const installedAgents = props.getAgents("installed");
  const newAgents = props.getAgents("notInstalled");

  const installedAgentsJsx = installedAgents.map(mapAgentsFn);
  const newAgentsJsx = newAgents.map(mapAgentsFn);

  return (
    <>
      <div
        className="nav-sidebar__fixed-navigation"
        style={{
          paddingBottom: 0,
        }}
      >
        <WebsiteSelector
          {...props}
          setSidebarMenu={setSidebarMenu}
          // onClickPath={`/agents/monetization/${currentAgent}`}
          hideSearch
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {installedAgents.length > 0 && (
            <SidebarMenuWrapper gap={8} title={"Installed agents"}>
              {installedAgentsJsx}
            </SidebarMenuWrapper>
          )}
          {newAgents.length > 0 && (
            <SidebarMenuWrapper
              gap={8}
              title={installedAgents.length > 0 ? "Explore" : null}
            >
              {newAgentsJsx}
            </SidebarMenuWrapper>
          )}
        </div>
      </div>
    </>
  );
};

interface DynamicPageMenuProps extends Props {
  setSidebarMenu: (menu: string) => void;
  dynamicPageMenuId: any;
  scrollToTop: () => void;
}
const DynamicPageMenu = (props: DynamicPageMenuProps) => {
  const page = props.websitesPages.items.find(
    (page) => page.id === props.dynamicPageMenuId
  );
  if (!page) {
    return (
      <>
        <div className="nav-sidebar__fixed-navigation">
          <SidebarButton
            onClick={() => {
              props.scrollToTop();
              props.setSidebarMenu("website");
            }}
            icon={<ArrowLeft size={16} />}
          >
            Dynamic page
          </SidebarButton>
        </div>
        <SidebarMenuWrapper>
          <Empty
            description="Page not found"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ margin: 0, marginTop: 16 }}
          />
        </SidebarMenuWrapper>
      </>
    );
  }

  useEffect(() => {
    props.callPageSource({ page, isFull: true });
  }, []);

  let parentUrl = page.url;
  !parentUrl ? (parentUrl = "Home page") : (parentUrl = `/${parentUrl}`);

  const dynamicPageData = props.getPageDynamicData({ page });
  const allSlugs = dynamicPageData.allSlugs;
  const isLoading = dynamicPageData.isLoading;

  const { currentWebsitePage } = props.getCurrentStoreData();

  const isCurrentPageSelected = _.get(currentWebsitePage, "id") === page.id;
  const slugParam = getUrlParameter("slug");
  const [searchValue, setSearchValue] = useState("");
  const MAX_ITEMS = 50;
  const [displayedSlugsCount, setDisplayedSlugsCount] = useState(MAX_ITEMS);

  useEffect(() => {
    setDisplayedSlugsCount(MAX_ITEMS);
  }, [searchValue]);

  const mapSlugsFn = ({ slug }) => {
    const isSelected = isCurrentPageSelected && slugParam === slug;
    const handleOnClick = () => {
      props.handleOnClickPage({
        pageId: page.id,
        slug,
        history: props.history,
      });
    };
    return (
      <SidebarButton
        key={slug}
        isSelected={isSelected}
        onClick={handleOnClick}
        icon={<File size={16} />}
        tooltip={
          <div className="nav-sidebar__button-tooltip-content">
            <div className="nav-sidebar__button-tooltip-title">
              {page.url ? `/${page.url}/${slug}` : `/${slug}`}
            </div>
          </div>
        }
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          {!!page.url && (
            <span
              style={{ color: "#8c8c8c" }}
              className="nav-sidebar__button-expand-item-prefix"
            >
              /{page.url}
            </span>
          )}
          <span className="nav-sidebar__button-expand-item-name">/{slug}</span>
        </span>
      </SidebarButton>
    );
  };

  let displayedSlugs = allSlugs.map((slug) => {
    return {
      slug,
    };
  });

  if (!!searchValue) {
    displayedSlugs = fuzzysort
      .go(searchValue, displayedSlugs, {
        keys: ["slug"],
      })
      .map((result) => {
        const { obj } = result as any;
        return obj;
      });
  }

  const paginatedSlugs = displayedSlugs.slice(0, displayedSlugsCount);
  const hasMoreSlugs = displayedSlugs.length > displayedSlugsCount;

  const handleShowMore = () => {
    setDisplayedSlugsCount((prev) => prev + MAX_ITEMS);
  };

  const dysplayedSlugsJsx = paginatedSlugs.map(mapSlugsFn);

  return (
    <>
      <div className="nav-sidebar__fixed-navigation">
        <SidebarButton
          onClick={() => {
            props.scrollToTop();
            props.setSidebarMenu("website");
          }}
          icon={<ArrowLeft size={16} />}
        >
          {parentUrl}
        </SidebarButton>
        {!isLoading && allSlugs.length > 0 && (
          <div className="nav-sidebar__search">
            <DebouncedInput
              prefix={<Search size={14} />}
              placeholder="Search..."
              debounceDelay={250}
              className="nav-sidebar__search-input"
              onChange={(value) => {
                setSearchValue(value);
              }}
              value={searchValue}
              autoFocus
            />
          </div>
        )}
      </div>
      {isLoading && (
        <SidebarMenuWrapper>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              padding: "0 8px",
            }}
          >
            <SidebarSkeletonLoader hasIcon width="120px" />
            <SidebarSkeletonLoader hasIcon width="85px" />
            <SidebarSkeletonLoader hasIcon width="140px" />
            <SidebarSkeletonLoader hasIcon width="110px" />
            <SidebarSkeletonLoader hasIcon width="95px" />
            <SidebarSkeletonLoader hasIcon width="130px" />
            <SidebarSkeletonLoader hasIcon width="100px" />
            <SidebarSkeletonLoader hasIcon width="115px" />
            <SidebarSkeletonLoader hasIcon width="90px" />
            <SidebarSkeletonLoader hasIcon width="125px" />
          </div>
        </SidebarMenuWrapper>
      )}
      {!isLoading && (
        <SidebarMenuWrapper>
          {allSlugs.length > 0 && dysplayedSlugsJsx}
          {allSlugs.length > 0 && hasMoreSlugs && (
            <SidebarButton onClick={handleShowMore}>
              ... show more
            </SidebarButton>
          )}
          {allSlugs.length > 0 &&
            !!searchValue &&
            displayedSlugs.length === 0 && (
              <Empty
                description="No results"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                style={{ margin: 0, marginTop: 16 }}
              />
            )}
          {allSlugs.length === 0 && (
            <Empty
              description="No nested pages found"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              style={{ margin: 0, marginTop: 16 }}
            />
          )}
        </SidebarMenuWrapper>
      )}
    </>
  );
};

const NavSidebar = (props: Props) => {
  if (!props.websites.dataFetched) {
    return null;
  }
  if (
    props.websites.dataFetched &&
    _.get(props.websites, "items", []).length === 0
  ) {
    return null;
  }
  const { currentWebsite, currentWebsitePage, currentBlogPost } =
    props.getCurrentStoreData();
  const fillTemplateProgress = _.get(currentWebsite, "fillTemplateData.status");

  if (fillTemplateProgress === "inProgress") return null;

  const pathArray = props.history.location.pathname
    .split("/")
    .filter((i) => !!i);
  const currentAppSection = pathArray[1];

  const defaultSidebarMenu =
    currentAppSection === "manage_agent"
      ? "hire"
      : currentAppSection === "blog"
      ? "blog"
      : "website";
  const [sidebarMenu, setSidebarMenu] = useState(defaultSidebarMenu);
  const [dynamicPageMenuId, setDynamicPageMenuId] = useState(null);
  const [expandedItems, setExpandedItems] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);

  const settingsModalType = props.websites.settingsModalType;
  const setSettingsModalType = props.setSettingsModalType;

  useEffect(() => {
    setExpandedItems([]);
  }, [_.get(currentWebsite, "id")]);

  const [selectedAgent, setSelectedAgent] = useState(
    currentAppSection === "cms"
      ? "data"
      : currentAppSection === "analytics"
      ? "analytics"
      : currentAppSection === "agents" && pathArray[2] === "growth"
      ? "growth"
      : currentAppSection === "agents" && pathArray[2] === "monetization"
      ? "monetization"
      : "web_dev"
  );

  useEffect(() => {
    if (selectedAgent === "hire") {
      return;
    }

    if (currentAppSection === "blog") {
      setSidebarMenu("blog");
    }
    if (currentAppSection === "pages") {
      setSidebarMenu("website");
    }
    if (currentAppSection === "cms") {
      setSidebarMenu("cms");
    }
    if (currentAppSection === "analytics") {
      setSidebarMenu("analytics");
    }
    if (currentAppSection === "agents" && pathArray[2] === "growth") {
      setSidebarMenu("growth");
    }
    if (currentAppSection === "agents" && pathArray[2] === "monetization") {
      setSidebarMenu("monetization");
    }
    if (currentAppSection === "manage_agent") {
      setSidebarMenu("hire");
    }
  }, [currentAppSection]);

  const sidebarWrapperRef = useRef<HTMLDivElement>(null);

  const scrollToTop = () => {
    if (sidebarWrapperRef.current && sidebarWrapperRef.current.scrollTo) {
      sidebarWrapperRef.current.scrollTo({
        top: 0,
      });
    }
  };

  const menusMap = {
    website: (
      <WebsiteMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        sidebarMenu={sidebarMenu}
        setSettingsModalType={setSettingsModalType}
        setDynamicPageMenuId={setDynamicPageMenuId}
        dynamicPageMenuId={dynamicPageMenuId}
        expandedItems={expandedItems}
        setExpandedItems={setExpandedItems}
        scrollToTop={scrollToTop}
      />
    ),
    theme: (
      <ThemeMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        sidebarMenu={sidebarMenu}
        scrollToTop={scrollToTop}
      />
    ),
    blog: (
      <BlogMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        sidebarMenu={sidebarMenu}
        setSettingsModalType={setSettingsModalType}
        scrollToTop={scrollToTop}
      />
    ),
    pageTemplates: (
      <PageTemplatesMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        scrollToTop={scrollToTop}
      />
    ),
    analytics: (
      <AnalyticsAgentMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
        scrollToTop={scrollToTop}
      />
    ),
    growth: (
      <GrowthAgentMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
        scrollToTop={scrollToTop}
      />
    ),
    monetization: (
      <MonetizationAgentMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
        scrollToTop={scrollToTop}
      />
    ),
    hire: (
      <HireNewAgentMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
        scrollToTop={scrollToTop}
      />
    ),
    dynamicPage: (
      <DynamicPageMenu
        {...props}
        setSidebarMenu={setSidebarMenu}
        dynamicPageMenuId={dynamicPageMenuId}
        scrollToTop={scrollToTop}
      />
    ),
  };

  // const chatHeight =
  //   sidebarMenu === "website"
  //     ? (_.get(props.websites, "demoChat.height") || 0) + 16
  //     : 0;
  const chatHeight = 0;

  const isCanvasEmpty =
    (currentAppSection === "pages" && !currentWebsitePage) ||
    (currentAppSection === "blog" && !currentBlogPost);

  const currentAgent = props.getCurrentAgent();

  return (
    <div
      className={classNames("nav-sidebar", {
        "is-nav-hidden":
          currentAppSection === "cms" ||
          currentAppSection === "agents" ||
          currentAppSection === "analytics",
        "is-canvas-empty":
          isCanvasEmpty || currentAppSection === "manage_agent",
        "is-scrolled": isScrolled,
      })}
    >
      <div className="nav-sidebar__sidepanel">
        <div className="nav-sidebar__sidepanel-wrapper">
          <AgentsMenu
            {...props}
            setSidebarMenu={setSidebarMenu}
            sidebarMenu={sidebarMenu}
            selectedAgent={selectedAgent}
            setSelectedAgent={setSelectedAgent}
            scrollToTop={scrollToTop}
          />
        </div>
      </div>
      <div
        className={"nav-sidebar__wrapper-outer"}
        style={{
          height: `calc(100vh - ${chatHeight}px)`,
        }}
        id="nav-sidebar-wrapper-outer"
        onScroll={(e) => {
          if (!e || !e.target) return;
          const target = e.target as HTMLDivElement;
          if (_.get(target, "id") === "nav-sidebar-wrapper-outer") {
            setIsScrolled(target.scrollTop > 0);
          }
        }}
        ref={sidebarWrapperRef}
      >
        <div className="nav-sidebar__wrapper">{menusMap[sidebarMenu]}</div>
      </div>
      <SearchModal setSidebarMenu={setSidebarMenu} />
      <SettingsModal
        saveWebsiteDataInStore={props.saveWebsiteDataInStore}
        saveWebsitePageDataInStore={props.saveWebsitePageDataInStore}
        publishPage={props.publishPage}
        saveImageInfoInDB={props.saveImageInfoInDB}
        removeImageFromDB={props.removeImageFromDB}
        saveBlogDataInStore={props.saveBlogDataInStore}
        saveBlogPostDataInStore={props.saveBlogPostDataInStore}
        publishPost={props.publishPost}
        type={settingsModalType}
        setSettingsModalType={setSettingsModalType}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    websites: state.websites,
    websitesPages: state.websitesPages,
    auth: state.auth,
    blogPosts: state.blogPosts,
    blogs: state.blogs,
    plans: state.plans,
    meta: state.meta,
  };
};
export default connect(mapStateToProps, {
  getWebsiteInitialPagesLoadStatus,
  getCurrentStoreData,
  createWebsiteFromTemplate,
  cloneWebsiteWaitingForServer,
  setFullWebsiteLoadStatus,
  fetchSingleWebsitePages,
  saveSingleWebsiteInState,
  deleteWebsiteWaitingForServer,
  removeWebsiteFromStore,
  removeWebsitePagesFromStore,
  cloneWebsitePageWaitingForServer,
  setPageLoadStatus,
  saveWebsitesPagesInState,
  deleteWebsitePageWaitingForServer,
  removeSingleWebsitePageFromStore,
  createAndSavePost,
  cloneBlogPostWaitingForServer,
  setSinglePostStatus,
  saveBlogsPostsInState,
  deleteBlogPostWaitingForServer,
  removeSingleBlogPostFromStore,
  changePageDynamicData,
  getPageDynamicData,
  changeWebsitesStateGlobalData,
  getSingleWebsiteLoadStatus,
  toggleWaitingForMovePageToAnotherWebsite,
  setUserStateData,
  getSingleBlogLoadStatus,
  getPageLoadStatus,
  getInitialPostsStatus,
  toggleWaitingForResponseOnColorPaletteChange,
  toggleWaitingForResponseOnFontChange,
  callPageSource,
  handleOnClickPage,
  setIsSettingsModalVisible,
  setIsSearchModalVisible,
  previewPage,
  previewPost,
  previewBlogHomePage,
  incrementEditorKey,
  incrementNavSidebarKey,
  isUserFreeNew,
  getCurrentAgent,
  getAgents,
  getAgentInstallData,
  checkIfAgentsAvailable,
  setSettingsModalType,
  duplicatePage,
  deletePage,
  duplicatePost,
  deletePost,
})(withRouter(NavSidebar));
